import './MobileCarousel.css';
import { CarouselProvider, Slider, Image, Slide, DotGroup } from 'pure-react-carousel';
import { Property } from '../../../../models/Property';

interface MobileCarouselProps {
  property: Property;
}

export default function MobileCarousel({ property }: MobileCarouselProps) {
  return (
    <CarouselProvider
      visibleSlides={1}
      totalSlides={property.images.length}
      step={1}
      naturalSlideHeight={100}
      naturalSlideWidth={150}
      isIntrinsicHeight={true}
      infinite={true}
    >
      <Slider id="geoconnect-property--carousel__mobile">
        {property.images.map((url: string, index: number) => (
          <Slide className='slide' key={`carousel--property-image-${index + 1}`} index={index}>
            <Image
              style={{ backgroundSize: 'contain' }}
              hasMasterSpinner={false}
              src={url}
              alt="some description" />
          </Slide>
        ))}
      </Slider>
      {property.images.length > 1 &&
        <div className="dot-wrapper__mobile">
          <DotGroup className='dot-group' />
        </div>
      }
    </CarouselProvider>
  )
}
